<h1 class="color-blue account__title guts-p-b-2 rel">
  {{ i18n.signupForm_SignUpTitle }}
</h1>
<form
  id="signupForm"
  name="signupForm"
  class="account__form"
  [formGroup]="signupForm"
>
  <form ngNoForm action="/account/register" method="POST">
    <input
      name="__RequestVerificationToken"
      type="hidden"
      value="{{ antiForgeryToken }}"
      data-dgat="signup-form-209"
    />
    <input
      id="returnUrl"
      name="returnUrl"
      type="hidden"
      value="{{ returnUrl }}"
      data-dgat="signup-form-b3d"
    />
    <input
      id="utm_source"
      name="utm_source"
      type="hidden"
      value="{{ utmSource }}"
      data-dgat="signup-form-e09"
    />
    <input
      id="utm_medium"
      name="utm_medium"
      type="hidden"
      value="{{ utmMedium }}"
      data-dgat="signup-form-241"
    />
    <input
      id="utm_campaign"
      name="utm_campaign"
      type="hidden"
      value="{{ utmCampaign }}"
      data-dgat="signup-form-a02"
    />
    <div class="account__message par" *ngIf="generalMessage">
      {{ generalMessage }}
    </div>
    <fieldset class="account__wrapper">
      <div class="email guts-m-b-1">
        <div class="left-text">
          <label for="email" class="delta account__label guts-m-t-half">{{
            i18n.signupForm_RegisterEmailLabel
          }}</label>
        </div>
        <input
          id="email"
          name="username"
          formControlName="email"
          type="email"
          required
          ngbAutoFocus
          [attr.aria-label]="i18n.signupForm_EmailPlaceholder"
          [placeholder]="i18n.signupForm_EmailPlaceholder"
          data-dgat="signupForm-b85"
          class="signup-textfield"
        />

        <dgx-validate-field
          class="left-text"
          *ngIf="
            signupForm.get('email').touched &&
            signupForm.get('email').errors?.required
          "
          [message]="'Core_FieldRequired' | translate"
        ></dgx-validate-field>
        <dgx-validate-field
          class="left-text"
          *ngIf="
            (signupForm.get('email').touched &&
              signupForm.get('email').errors?.invalidEmail) ||
            (signupForm.get('email').touched &&
              signupForm.get('email').errors?.existingEmail)
          "
          [message]="emailValidationMessage"
        ></dgx-validate-field>
      </div>
      <div class="grid grid--bleed">
        <div class="grid__col-6">
          <div class="firstname guts-p-r-half guts-m-b-1">
            <div class="left-text">
              <label
                for="firstname"
                class="delta account__label guts-m-t-half"
                >{{ i18n.signupForm_RegisterFirstNameLabel }}</label
              >
            </div>
            <input
              id="firstname"
              name="firstname"
              formControlName="firstname"
              type="text"
              required
              [attr.aria-label]="i18n.signupForm_FirstNamePlaceholder"
              [placeholder]="i18n.signupForm_FirstNamePlaceholder"
              autocomplete="given-name"
              data-dgat="signupForm-798"
              class="signup-textfield"
            />
            <dgx-validate-field
              class="left-text"
              [message]="
                signupForm.get('firstname').touched &&
                signupForm.get('firstname').errors &&
                ('Core_FieldRequired' | translate)
              "
            ></dgx-validate-field>
          </div>
        </div>
        <div class="grid__col-6 guts-m-b-1">
          <div class="lastname guts-p-l-half">
            <div class="left-text">
              <label
                for="lastname"
                class="delta account__label guts-m-t-half"
                >{{ i18n.signupForm_RegisterLastNameLabel }}</label
              >
            </div>
            <input
              id="lastname"
              name="lastname"
              formControlName="lastname"
              type="text"
              [attr.aria-label]="i18n.signupForm_LastNamePlaceholder"
              [placeholder]="i18n.signupForm_LastNamePlaceholder"
              autocomplete="family-name"
              data-dgat="signupForm-dac"
              class="signup-textfield"
            />
            <dgx-validate-field
              class="left-text"
              [message]="
                signupForm.get('lastname').touched &&
                signupForm.get('lastname').errors &&
                ('Core_FieldRequired' | translate)
              "
            ></dgx-validate-field>
          </div>
        </div>
      </div>
      <div class="guts-m-b-1">
        <div class="left-text">
          <label for="password" class="delta account__label guts-m-t-half">{{
            i18n.signupForm_CreatePasswordLabel
          }}</label>
          <df-icon
            icon="info"
            size="small"
            placement="top"
            container="'body'"
            [ngbTooltip]="i18n.signupForm_CreatePasswordTooltip"
            [attr.aria-label]="i18n.signupForm_CreatePasswordTooltip"
            tabindex="0"
            role="text"
            class="color-ebony-a45 guts-m-l-half"
            data-dgat="signupForm-5fc"
          ></df-icon>
        </div>
        <input
          id="password"
          name="password"
          formControlName="password"
          type="password"
          [placeholder]="i18n.signupForm_CreatePasswordPlaceholder"
          [attr.aria-label]="i18n.signupForm_CreatePasswordTooltip"
          required
          data-dgat="signupForm-fe4"
          autocomplete="new-password"
          class="signup-textfield"
        />
        <dgx-validate-field
          class="left-text"
          [message]="
            signupForm.get('password').touched &&
            signupForm.get('password').errors &&
            ('Core_FieldRequired' | translate)
          "
        ></dgx-validate-field>
      </div>
      <div class="guts-p-b-1 guts-p-t-3 rel">
        <button
          (click)="submit($event)"
          type="submit"
          [disabled]="
            !signupForm.valid || signupForm.pending || !isValidCaptcha
          "
          [class.is_disabled]="
            !signupForm.valid || signupForm.pending || !isValidCaptcha
          "
          class="full-width submit-button"
          id="continueBtn"
          df-button
          dfButtonType="primary"
          data-dgat="signupForm-1c2"
        >
          <df-spinner-button [isSpinning]="saving">
            {{ i18n.AccountController_Continue }}
          </df-spinner-button>
        </button>
      </div>

      <div
        dgxRecaptcha
        *ngIf="showCaptcha"
        [siteKey]="captchaKey"
        (recaptchaSuccess)="recaptchaSuccess($event)"
        (recaptchaExpired)="recaptchaExpired()"
        class="guts-m-t-1 guts-m-b-2"
      ></div>
    </fieldset>
    <section class="center-text">
      <div class="m-guts-p-t-2 delta account__signup-login-now">
        <strong class="font-bold guts-m-r-0">{{
          i18n.signupForm_HasAccountCTA
        }}</strong>
        <a
          href="{{ loginUrl }}"
          class="link guts-p-l-half"
          data-dgat="signupForm-858"
        >
          <span>{{ i18n.signupForm_LogInNow }}</span
          >.
        </a>
      </div>
    </section>
  </form>
</form>
